import { eventsWithoutTI, eventWithTIDeactivated } from '@/config/addOnsConfig';

export default function useAddOnsConfig() {
  const isEventWithoutTicketInsurance = (eventId) =>
    eventsWithoutTI.includes(eventId);

  const isEventWithTIDeactivated = (eventId) =>
    eventWithTIDeactivated.includes(eventId);

  return {
    isEventWithoutTicketInsurance,
    isEventWithTIDeactivated,
  };
}
